import DeviceManager from '../utils/device-manager';
import $ from "jquery";
import Flickity from "flickity-fade";
import "flickity-imagesloaded";

class LogosSlider {
    constructor($el) {
        this.$el = $el;

        this.options = {
            autoPlay: true,
            pageDots: false,
            wrapAround: true,
            prevNextButtons: false,
            freeScroll: true,
            cellSelector: '.home-press__logos-item',
            cellAlign: 'left',
            imagesLoaded: true,
        };

        if(this.$el.length) {
            this._init();
            this._bindEvents();
        }
    }

    _init() {
        this.$slides = this.$el.find('.home-press__logos-item');
        this.slidesCount = this.$slides.length;

        if (document.body.clientWidth < 992 && this.slidesCount > 1) {
            this.slider = new Flickity(this.$el[0], this.options);
        } else {
            this._destroy();
        }
    }

    _bindEvents() {
        this._onBreakpointChangeFn = this._onBreakpointChange.bind(this);

        DeviceManager.on('device-manager:breakpointChange', this._onBreakpointChangeFn);
    }
    
    _destroy() {
        if(this.slider) {
            this.slider.destroy();
            this.slider = null;
        }
    }

    _onBreakpointChange() {
        if (document.body.clientWidth < 992 && this.slidesCount > 1) {
            this.slider = new Flickity(this.$el[0], this.options);
        } else {
            this._destroy();
        }
    }
}

export default LogosSlider;